import React from 'react';
import { UserDataProvider } from './userData.context';
import { SideBarOpenedProvider } from './sideBarOpened.context';
import PermissionsProvider from './permissions.context';
import { WritersProvider } from './writers.context';
import { UserAccessProvider } from './userAccess.context';

export const StoreProvider: React.FC = ({ children }) => {
  return (
    <UserDataProvider>
      <SideBarOpenedProvider>
        <PermissionsProvider>
          <WritersProvider>
            <UserAccessProvider>
              {children}
            </UserAccessProvider>
          </WritersProvider>
        </PermissionsProvider>
      </SideBarOpenedProvider>
    </UserDataProvider>
  );
};
